export default __webpack_public_path__ + "static/media/wechat.f6953289.png";